import { useCallback, useState } from 'react';
import { useGetBoardDeployStatus } from '@/hooks/apiHooks';

export const useFetchDeployUrl = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const [errorDetail, setErrorDetail] = useState('');

  const fetchDeployUrl = useCallback(async (boardId: string) => {
    setIsLoading(true);
    setError('');
    setErrorDetail('');

    const errorTitle = '배포 정보를 불러올 수 없어요.';
    const errorDetail =
      '파일을 다시 업로드해 주세요. 문제가 지속되면 IT Service에 문의해 주세요.';

    try {
      const result = await useGetBoardDeployStatus(boardId);

      if (result.url) {
        setUrl(result.url);
        setError('');
        setErrorDetail('');
        return { success: true, url: result.url, response: result };
      } else {
        setError(errorTitle);
        setErrorDetail(errorDetail);
        return {
          success: false,
          error: errorTitle,
          errorDetail,
          response: result,
        };
      }
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || '';
      const response = error?.response?.data;
      const detail = errorMessage
        ? `${errorDetail}\n${errorMessage}`
        : errorDetail;
      setError(errorTitle);
      setErrorDetail(detail);
      return { success: false, error: errorTitle, errorDetail: detail, response };
    } finally {
      setIsLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setUrl('');
    setError('');
    setErrorDetail('');
    setIsLoading(false);
  }, []);

  return {
    isLoading,
    url,
    error,
    errorDetail,
    fetchDeployUrl,
    reset,
  };
};
